import { initializeQtyComponent, isIOS, loadLazyImages } from "../utilities/globalUtilities";
import { buildLoyaltyCouponCardList, verifyAndCheckAppliedCarouselCoupons, updateSelectAllCouponsInput } from "../components/loyaltyUtils";
import { getMessageAndShowRemovalConfirmModal, initCartCouponsEvents } from "./components/cartCoupons";
import { adjustSummaryBlocks, removeAlternativeProductsPartOfBasket, validateBasket, updateApproachingDiscounts, updateCartProductTilesPriceInformation, updateCouponsSummary, updateCartTotals, updateCartSummary } from "../components/cartUtil";
import { stickySummaryWrapperInit } from "../checkout/summaryCT";
import { scrollToElement, scrollInputFieldIntoView } from "../utilities/scrollToElement";
import { showPlaceOrderPopupError } from "../checkout/components/placeOrderPopupError";
import { showCoverageAreaModal } from "../checkout/components/showCoverageAreaModal";
import { swipeTile } from "../components/removeItemAnimations";
import { initProductQuantity } from "../components/quantity";
import { CART, MIN_PRODUCT_QUANTITY } from "../utilities/constants";
import { PRICETYPES } from "../utilities/constants";
import { removeCurrencyFromStringAndConverToNumber } from "../components/convertUtils";
import { setIsAllSelected, saveSelectedCouponInCache, getAllCachedCoupons, removeCouponFromCache, getCachedCouponsSelected, removeDuplicates, getIsAllSelected } from "./components/CouponsCarouselComponentJQuery";
import { loadingDots, disableLoadingDots } from "../components/pageLoading";
import { triggerInitWishlistTogglers } from "../wishlist/wishlist";

let base = require("../product/base");
let focusHelper = require("../components/focus");
let urlUtils = require("../search/urlUtils");
let altProductsCarouselVueJS = require("../vue/components/alternativeProducts/alternativeCarousel");
const scrollLock = require("../utilities/scrollLock");
const cartUtil = require("../components/cartUtil");
const confirmationToast = require("../components/confirmationToast");
const regex = require("../utilities/regex");
const debounce = require("lodash/debounce");
const mqueryRespond = window.mqRespond;

const $cache = {
    body: $("body"),
    window: $(window),
    appliedCouponsWrapper: $(".ct-cart--applied-coupons-wrapper"),
    pageTypeValue: $("[data-page-type]").data("page-type")
};

let productRemovalActions = {};

/**
 * @function
 * @description - Remove the last product tile separator, after adding an alternative product
 */
const removeLastSeparator = () => {
    const $productList = document.querySelector(".ct-cart--product-list");
    const $separators = $productList.querySelectorAll("hr");

    if ($separators.length > 0) $separators[$separators.length - 1].remove();
};

/**
 * Updates the products area after replace product action
 * @param {Object} data
 */
const updateProductAreaAfterReplace = data => {
    if (data) {
        const $responseElement = $(data);
        const unavailableItem = $responseElement.hasClass("item-unavailable");
        const $productInfo = $responseElement.find(".js-product-info").length ? $responseElement.find(".js-product-info") : $responseElement;
        const categoryName = $productInfo.attr("data-category-name");
        const anchorName = $productInfo.attr("data-anchor-name");
        const previousProductBrand = $productInfo.attr("data-previous-product-brand");
        const brandID = $productInfo.attr("data-brand-id");
        const brandItems = parseInt($(`#js-current-products-${brandID}`).html(), 10);
        const isNewCategory = $responseElement.hasClass("js-ct-category-line-items-container");
        const productIndex = !isNaN($productInfo.attr("data-product-index")) ? parseInt($productInfo.attr("data-product-index"), 10) - 1 : null;
        const categoryIndex = !isNaN($productInfo.attr("data-category-index")) ? parseInt($productInfo.attr("data-category-index"), 10) : null;

        if (unavailableItem) {
            $(`.js-current-brand-${brandID} .js-unavailable-block`).after(data);
        } else if (!brandItems) {
            const unavailableBrandProducts = $(`.js-out-of-stock-products-${previousProductBrand}`) || $(`.js-out-of-stock-products-${brandID}`);
            if (unavailableBrandProducts?.children()?.length <= 1) {
                const currentBrand = $(`.js-current-brand-${previousProductBrand}`) || $(`.js-current-brand-${brandID}`);
                const brandIndex = currentBrand.index();
                currentBrand.remove();
                const container = $(".ct-cart--product-list");
                const children = container.children();

                if (brandIndex < children.length) {
                    $(data).insertBefore(children.eq(brandIndex));
                } else {
                    container.append(data);
                }
            } else {
                data = data.replace("<hr />", "");
                $(`.js-current-brand-${brandID}`).after(data);
            }

        } else {
            var categoryContainers = $(`.js-current-brand-${brandID} .js-ct-category-line-items-container`);
            if (!isNewCategory) {
                categoryContainers.each(function () {
                    if ($(this).attr("data-category-name") == categoryName) {
                        if (productIndex > 0) {
                            $(this).find(".js-product-info").eq(productIndex).after(data);
                        } else {
                            $(this).find(".js-product-info").eq(0).before(data);
                        }
                    }
                });
            } else if (categoryContainers.length > 0) {
                if (categoryIndex === 0) {
                    categoryContainers.eq(categoryIndex).before(data);
                } else {
                    categoryContainers.eq(categoryIndex-1).after(data);
                }
            }
        }

        loadLazyImages();
        if (!unavailableItem) {
            $(`#js-current-products-${brandID}`).text(brandItems + 1);

            if (anchorName && anchorName != "null") {
                scrollToElement($(`#${anchorName}`), 1500);
            }
        }

        if (categoryIndex == $(".js-ct-category-line-items-container:not(.js-out-of-stock-products)").length) {
            removeLastSeparator();
        }

        triggerInitWishlistTogglers();
    }
};

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
        "fade show\" role=\"alert\">" +
        "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
        "<span aria-hidden=\"true\">&times;</span>" +
        "</button>" + message + "</div>";

    $(".cart-error").append(errorHtml);

    //GTM logic - Start
    document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
        detail: {
            "success": false,
            "messageContent": message
        }
    }));
    //GTM logic - End
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Render the promotion badge and message on cart tile
 * @param {Object} promo - object containing the promotion keys
 * @param {Element} element - cart tile element that will be updated
 */
const handlePromoBadgeHTML = (promo, element) => {
    const $cartTile = element;

    if (promo && Object.keys(promo).length) {
        const { discount, unit, type, showDiscountValue, showDiscountMessage, showPlusDESignOnBadge, plusLabel, thanLabel, floatValue, msg: promoMessage, img, alt, title } = promo;
        let badgeDiscountHTML = "";
        let badgeHTML = "";
        let discountHTML = "";

        if (discount && unit && showDiscountValue) {
            badgeDiscountHTML =
            `
                <div class="ct-product-tile-badge-value-wrapper ct-product-tile-badge-value-wrapper--${type} ${type == "superprice" && showDiscountMessage ? "ct-product-tile-badge-value-wrapper--with-text" : ""} ${floatValue ? "ct-product-tile-badge-value-wrapper--float" : ""}">
                    <div class="ct-product-tile-badge-addition d-none flex-column align-self-center text-center ${showPlusDESignOnBadge ? "d-flex" : ""}">
                        <span class="ct-product-tile-badge-addition--sign">
                            ${plusLabel}
                        </span>
                        <span class="ct-product-tile-badge-addition--text">
                            ${thanLabel}
                        </span>
                    </div>
                    <span class="ct-product-tile-badge-value--${type}">
                        ${discount}
                    </span>
                    <span class="ct-product-tile-badge-value--${type}-quantifier ${type == "superprice" && showDiscountMessage ? "d-none" : ""}">
                        ${unit}
                    </span>
                </div>
            `;
        }

        if (promoMessage) {
            let badgeClass = "pwc-discount-amount";
            if (type == PRICETYPES.PVPR) {
                badgeClass = badgeClass + " pwc-discount-amount-pvpr";
            }
            discountHTML =`<p class="${badgeClass}">${promoMessage}</p>`;
        }

        badgeHTML =
        `
            <div class="ct-cart-tile-badge ct-cart-tile-badge--promotional">
                <img class="img-fluid lazyload hidden"
                    loading="lazy"
                    data-src="${img}"
                    alt="${alt}"
                    title="${title}" />

                ${badgeDiscountHTML}
            </div>
        `;

        $cartTile.find(".ct-cart-tile-badge.ct-cart-tile-badge--promotional").remove();
        $cartTile.find(".pwc-discount-amount").remove();
        $cartTile.find(".ct-cart-tile-details").append(discountHTML);
        $cartTile.find(".ct-cart-tile-image-container").append(badgeHTML);
    } else {
        $cartTile.find(".ct-cart-tile-badge.ct-cart-tile-badge--promotional").remove();
        $cartTile.find(".pwc-discount-amount").remove();
    }
};

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid, oldPid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    var $cartTile = $(`.ct-cart-tile[data-pid="${oldPid}"]`);
    var newPid = data.newProductId;
    const { badgeInfo = {} } = lineItem;
    const { promo = {} } = badgeInfo;

    if (lineItem.variationAttributes) {
        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === "color";
        });

        if (colorAttr) {
            var newImageUrl = colorAttr.images["swatch"].length > 0 ? colorAttr.images["swatch"][0].url : "";
            $(`.ct-cart-tile-attribute--color[data-uuid="${uuid}"] .swatch-value`).css("background-image", `url(${newImageUrl})`);
        }

        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
            return attr.attributeId === "size";
        });

        if (sizeAttr) {
            $(`.ct-cart-tile-attribute--size[data-uuid="${uuid}"]`).text(sizeAttr.displayValue);
        }

        var $imageSelector = $cartTile.find(".ct-product-image");
        var onErrorFallback = `this.onerror=null;this.src='${lineItem.disImage.fallbackimage.url}';`;

        $imageSelector.attr("src", lineItem.disImage.url);
        $imageSelector.attr("data-src", lineItem.disImage.url);
        $imageSelector.attr("onerror", onErrorFallback);
        $imageSelector.attr("alt", lineItem.disImage.alt);
        $imageSelector.attr("title", lineItem.disImage.title);
    }

    handlePromoBadgeHTML(promo, $cartTile);

    var qvButton = $(`.cart-quickview[data-uuid="${uuid}"]`);
    var qvUrl = urlUtils.updateQueryParameter(qvButton.attr("href"), "pid", newPid);
    qvButton.attr("href", qvUrl);

    $cartTile.attr("data-pid", newPid);
    let productInfo = $(`.js-product-info[data-pid="${oldPid}"]`);
    productInfo.find(".pwc-tile--description").text(lineItem.productName);
    var wishlistToggler = productInfo.find(".wishlist-toggler");
    wishlistToggler.attr("data-pid", newPid);
    const addUrl = wishlistToggler.attr("data-add-url").replace(oldPid, newPid);
    const removeUrl = wishlistToggler.attr("data-remove-url").replace(oldPid, newPid);
    wishlistToggler.attr("data-add-url", addUrl);
    wishlistToggler.attr("data-remove-url", removeUrl);
    wishlistToggler.removeAttr("data-initialized");

    $(`.js-product-info[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.ct-cart-tile-bottom-details[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.update-substitute-form[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.js-cart-add-note-btn[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.note-preview-section[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.ct-cart-tile-notes[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.add-note-section[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.add-product-note[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`input[name="productID"][value="${oldPid}"]`).val(newPid);
    $(`.ct-remove-product[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.ct-cart-tile-undo-remove[data-pid="${oldPid}"]`).attr("data-pid", newPid);
    $(`.remove-product[data-uuid="${uuid}"]`).attr("data-pid", newPid);

    cartUtil.updateCartPriceInformation(uuid, data.cartModel);
    cartUtil.displayConfirmationToast($(`.js-add-to-cart-button[data-pid="${newPid}"]`), lineItem.quantity);
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $(".cart-delete-confirmation-btn");
    var $productToRemoveSpan = $(".product-to-remove");

    $deleteConfirmBtn.data("pid", productID);
    $deleteConfirmBtn.data("action", actionUrl);
    $deleteConfirmBtn.data("uuid", uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * @function
 * @description - Completely removed the category from the cart, if the last product from the category was removed
 * @param {Element} $removedProductCategory - Removed product category
 */
const removeCartCategory = $removedProductCategory => {
    const $productsInCategory = $removedProductCategory.find(".ct-cart-tile");

    if ($productsInCategory.length === 0) {
        $removedProductCategory.remove();
    }
};

/**
 * @function
 * @description - Init the events for the coupons carousel
 */
const initCouponCarouselEvents = () => {
    //Add button type to prevent default form submit
    addButtonTypeToCouponsCarousel();

    // Check/Uncheck all the coupon items
    $cache.body.off("change", ".select-all-coupon-tiles").on("change", ".select-all-coupon-tiles", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $couponItems = $(".coupon-carousel-input");
        const isChecked = $this.is(":checked");
        const activeBrand = $(".js-button-coupon-selector.active").data("brand-id");
        if (activeBrand == "all" && isChecked == true) {
            setIsAllSelected(true);
        } else {
            setIsAllSelected(false);
        }

        if (isChecked == false) {
            // clear user selection
            submitUserSelectionsForCoupons([]);

            // remove coupon from cache
            $couponItems.each((index, item) => {
                let couponID = $(item).val();
                removeCouponFromCache(`coupon-${couponID}`);
            });
        }

        $couponItems.each((index, item) => {
            $(item).prop("checked", isChecked);

            if (!isChecked) {
                const couponUUID = $(item).val();

                if (couponUUID) {
                    $(`.coupon-uuid-${couponUUID}`).remove();
                }
            }
        });

        applyCustomerBenefitsCoupons();
    });

    // Event for coupon carousel item input checkbox
    $cache.body.off("change", ".coupon-carousel-input").on("change", ".coupon-carousel-input", e => {
        e.preventDefault();

        const $this = $(e.target);
        const couponID = $this.attr("id");
        const couponUUID = $this.val();
        const $visibleCouponCheck = $(`.slick-slide:not(.slick-cloned) #${couponID}`);
        const $allCouponTiles =  $(".select-all-coupon-tiles");
        const $appliedCouponCard = $(`.ct-cart--applied-coupon-card[data-uuid="${couponUUID}"]`);
        const couponFromCarousel = true;

        // save user selected coupons
        saveSelectedCouponInCache(couponID);

        if ($visibleCouponCheck.length > 0) {
            $visibleCouponCheck.prop("checked", $this.is(":checked"));
        }

        if (!$this.is(":checked")) {
            $allCouponTiles.prop("checked", false);
            $appliedCouponCard.find(".remove-coupon").trigger("click", couponFromCarousel);
        } else {
            applyCustomerBenefitsCoupons();
        }
    });

    // Remove the carousel coupon check only after the coupon removal is complete
    $cache.body.off("click", ".coupon-carousel-input").on("click", ".coupon-carousel-input", e => {
        const currentElement = e.currentTarget;
        const isChecked = currentElement.checked;

        if (isChecked) return;

        e.preventDefault();

        const cartCouponUUID = currentElement.value;
        const $selectAllElement = $(".select-all-coupon-tiles");

        $selectAllElement.prop("checked", false);
        // remove coupon from cache
        removeCouponFromCache(`coupon-${cartCouponUUID}`);
        setIsAllSelected(false);
        // trigger delete
        $(".js-delete-coupon-confirmation").trigger("click", cartCouponUUID);
    });
};

/**
 * Add button type to prevent the default submit behavior
 */
const addButtonTypeToCouponsCarousel = () => {
    setTimeout(() => {
        $(".slick-dots button").attr("type", "button");
    }, 200);
};

/**
 * @function
 * @description - Applies the customer selected vouchers/gifts
 */
const applyCustomerBenefitsCoupons = () => {
    const currentBrandID = $(".js-button-coupon-selector.active").data("brand-id");
    if (getIsAllSelected() == true && currentBrandID == "all") {
        const getAllCoupons = getAllCachedCoupons();
        submitUserSelectionsForCoupons(getAllCoupons);
    } else {
        const carouselCoupons = [];

        const $tiles = $(".slick-slide:not(.slick-cloned) .coupon-carousel-input");

        if ($tiles && $tiles.length) {
            $tiles.each((index, item) => {
                const $item = $(item);
                const itemVal = $item.val();
                const description = $item.attr("data-description");
                const amount = $item.attr("data-amount");
                const unit = $item.attr("data-unit");
                const isCarousel = $item.attr("data-is-carousel");
                const $couponInfo = {
                    id: itemVal,
                    description: description,
                    amount: amount,
                    unit: unit,
                    isCarouselCoupon: isCarousel
                };
                if (itemVal && $item.is(":checked")) {
                    carouselCoupons.push($couponInfo);
                }
            });
        }

        // get cached coupons and append to the selected coupons
        const getSelectedCoupons = getCachedCouponsSelected();
        const getAllCoupons = getAllCachedCoupons();
        let auxArray = removeDuplicates(getSelectedCoupons);

        // build object of coupon
        for (let i = 0; i < auxArray.length; i++) {
            let selectedCoupon = auxArray[i];
            let couponID = selectedCoupon.slice(7, selectedCoupon.length);
            for (let j = 0; j < getAllCoupons.length; j++) {
                const originalCoupon = getAllCoupons[j];
                // if coupon ID selected == to ID of original coupon
                if (couponID == originalCoupon.id) {
                    carouselCoupons.push(originalCoupon);
                }
            }
        }

        let finalArray = carouselCoupons.filter((value, index, self) =>
            index === self.findIndex((coupon) => (
                coupon.id === value.id
            ))
        );

        // submit
        submitUserSelectionsForCoupons(finalArray);
    }
};

/**
 * @function
 * @description - Submit the user selection from coupons carousel
 * @param {Array} carouselCoupons - Coupons array
 */
const submitUserSelectionsForCoupons = (carouselCoupons) => {
    const url = $("form.coupon-carousel-form").attr("action");
    const $acumulaWrapper = $(".js-acumula-area");

    $.spinner().start();

    $.ajax({
        url: url,
        type: "POST",
        context: this,
        dataType: "JSON",
        data: {
            carouselCoupons: JSON.stringify(carouselCoupons)
        },
        success: function (data) {
            if (data) {
                if (data.totalAcumulaDiscount && data.totalAcumulaDiscount != "0,00" && data.totalAcumulaDiscount != "N/A" && data.totalAcumulaDiscount != "NaN") {
                    $acumulaWrapper.find(".total-discount-value").empty().append("€" + data.totalAcumulaDiscount);
                    if ($acumulaWrapper.hasClass("d-none")) {
                        $acumulaWrapper.removeClass("d-none");
                    }
                } else {
                    if (!$acumulaWrapper.hasClass("d-none")) {
                        $acumulaWrapper.addClass("d-none");
                    }
                }

                const $appliedCouponsArea = $(".coupons-and-promos");
                const listOfAppliedCoupons = [];

                $appliedCouponsArea.find(".remove-coupon").each((idx, item) => {
                    const couponValue = $(item).attr("data-code");

                    if (couponValue) {
                        listOfAppliedCoupons.push(couponValue);
                    }
                });

                if (data.loyaltyCoupons) {
                    const appliedCoupons = data.loyaltyCoupons.gifts.concat(data.loyaltyCoupons.vouchers);
                    const difference = appliedCoupons.filter(x => !listOfAppliedCoupons.includes(x.id));
                    const loyaltyCouponsHTML = buildLoyaltyCouponCardList(difference);

                    verifyAndCheckAppliedCarouselCoupons(appliedCoupons);
                    $cache.appliedCouponsWrapper.last().append(loyaltyCouponsHTML);
                }
            }
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
        complete: function () {
            setTimeout(() => {
                $("#js-trigger-checkbox").trigger("click");
            }, 100);
        }
    });
};

/**
 * Clear coupons error
 */
const clearCouponErrors = () => {
    const $couponErrorMessage = $(".coupon-error-message");
    const $couponMissingError = $(".coupon-missing-error");

    $couponErrorMessage.empty().addClass("d-none");
    $couponMissingError.addClass("d-none");
};

/**
 * Bind events for the add coupons form
 */
const bindCouponFormEvents = () => {
    const toggleCouponButtonsVisibility = ($form, show) => {
        $form.find(".js-add-coupon-button, .js-coupon-reset-button").toggleClass("d-block", show);
        $form.find(".js-promo-code-btn").toggleClass("d-none", show);
    };

    $cache.body.off("click", ".js-promo-code-btn").on("click", ".js-promo-code-btn", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $form = $this.closest(".promo-code-form");
        $form.find(".coupon-code-field").focus();
        $this.tooltip("hide");
    });

    $cache.body.off("click", ".js-add-coupon-button").on("click", ".js-add-coupon-button", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $form = $this.closest(".promo-code-form");
        $form.trigger("submit");
        $this.tooltip("hide");
    });

    $cache.body.off("click", ".js-coupon-reset-button").on("click", ".js-coupon-reset-button", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $form = $this.closest(".promo-code-form");
        $form.find(".coupon-code-field").val("").blur();
        clearCouponErrors();
    });

    $cache.body.off("focusin", ".coupon-code-field").on("focusin", ".coupon-code-field", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $form = $this.closest(".promo-code-form");
        toggleCouponButtonsVisibility($form, true);

        if (window.mqRespond.status.mobile) {
            scrollInputFieldIntoView($this);
        }
    });

    $cache.body.off("focusout", ".coupon-code-field").on("focusout", ".coupon-code-field", e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        const $form = $this.closest(".promo-code-form");
        if ($form.find(".js-add-coupon-button").is(":focus") || $this.val() !== "") {
            return;
        }
        clearCouponErrors();
        toggleCouponButtonsVisibility($form, false);
    });
};

/**
 * Show modal with message that qty was updated due to the inventory update
 */
const showQtyUpdatedModal = () => {
    const $cardProductList = $(".js-cart-product-list");
    const showInventoryUpdatedModal = $cardProductList?.data("show-inventory-updated-modal");
    const $inventoryUpdatedModal = $("#inventory-updated-modal");

    if (showInventoryUpdatedModal) {
        $inventoryUpdatedModal.modal("show");
        cartUtil.updateCartSummaryModalClass(true);
        $inventoryUpdatedModal.on("hide.bs.modal", () =>{
            showCoverageAreaModal();
        });

        return;
    }

    showCoverageAreaModal();
};

/**
 * Disable the button in the cart for the specific product, if there were no alternatives for it
 */
const disableAlternativeProductButton = () => {
    const $alternativeModal = $("#alternative-product-modal");

    if ($alternativeModal.length) {
        $alternativeModal.on("hide.bs.modal", () => {
            const alternativeProductsLength = document.querySelectorAll(".alternative-product").length;
            const hasServerError = document.querySelector(".no-alternative-products")?.classList.contains("server-error");
            const unavailableProductID = document.querySelector(".ct-alternative-unavailable-product")?.querySelector("[data-alt-pid]")?.dataset.altPid;

            if (alternativeProductsLength === 0 && (hasServerError !== undefined && !hasServerError)) {
                const unavailableProductSection = document.querySelector(".js-out-of-stock-products");
                if (unavailableProductSection === null) { return; }
                const unavailableProductButtonArr = [...unavailableProductSection.querySelectorAll(`.js-alternative-products[data-orig-pid="${unavailableProductID}"]`)];

                if (unavailableProductButtonArr.length) {
                    unavailableProductButtonArr.forEach(btn => btn.disabled = true);
                }
            }
        });
    }
};

const initAddNoteBtns = () => {
    let $cartNotesBtns = document.querySelectorAll(".js-cart-add-note-btn");

    $cartNotesBtns.forEach(element => {
        $(element).off("click").on("click", e => {
            const $this = e.currentTarget;
            const productID = $this.dataset.pid;
            const productSavedNoteSection = document.querySelector(`.note-preview-section[data-pid='${productID}']`);
            const productSavedNote = productSavedNoteSection.querySelector(".note-preview-display");
            const productSavedNoteValue = productSavedNote ? productSavedNote.innerHTML.trim() : "";
            cartUtil.setCartNotesDisplay();
            var productModal = $("#product-note-modal");
            productModal.attr("data-product-id", productID);
            productModal.attr("data-saved-note", productSavedNoteValue);
            productModal.modal("show");

            if (window.mqRespond.status.mobile && $this.dataset.originalTitle != "") {
                const tooltipID = $this.getAttribute("aria-describedby");

                document.querySelector(`#${tooltipID}`).remove();
            }
        });
    });
};

/**
 * Setup the necessary Event Listeners for the summary swipe functionality on mobile devices
 */
const setupSummarySwipe = () => {
    const summaryDrag = document.getElementById("js-cart-summary-container");
    const body = document.body;
    let startY = 0;
    let endY = 0;
    let isSwiping = false;

    // Create and append the overlay element
    const overlay = document.createElement("div");
    overlay.className = "cart-summary-overlay";
    body.appendChild(overlay);

    // Get the summary wrapper element
    const $summaryWrapper = $(summaryDrag)
        .closest(".ct-cart--summary-wrapper")
        .find(".ct-cart--summary-details");

    /**
     * Toggle the visibility of the cart summary and overlay
     * @param {boolean} isOpen - Whether to open (true) or close (false) the summary
     */
    function toggleCartSummary(isOpen) {
        const action = isOpen ? "add" : "remove";
        body.classList[action]("cart-summary-opened");
        overlay.classList[action]("active");

        const actionFn = isOpen ? "slideDown" : "slideUp";
        const summarySection = $(".ct-cart--subtotal-section");

        summarySection.toggleClass("mt-2", !isOpen).toggleClass("mt-4", isOpen);
        $summaryWrapper.stop()[actionFn]("200", adjustSummaryBlocks);
    }

    /**
     * Start swipe detection by recording the initial touch position
     * @param {TouchEvent} e - The touch start event
     */
    function handleTouchStart(e) {
        startY = e.touches[0].clientY;
        isSwiping = true;
    }

    /**
     * Track the swipe movement by recording the current touch position
     * @param {TouchEvent} e - The touch move event
     */
    function handleTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
        if (isSwiping) {
            endY = e.touches[0].clientY;
        }
    }

    /**
     * Determine the swipe direction and perform the corresponding action
     */
    function handleTouchEnd() {
        if (isSwiping) {
            const distanceY = startY - endY;

            // Trigger action based on swipe distance
            toggleCartSummary(distanceY > 0); // Open if swipe up, close if swipe down

            isSwiping = false;
        }
    }

    // Attach touch event listeners to the summary drag element
    if (summaryDrag && overlay) {
        summaryDrag.addEventListener("touchstart", handleTouchStart, { passive: true });
        summaryDrag.addEventListener("touchmove", handleTouchMove);
        summaryDrag.addEventListener("touchend", handleTouchEnd);

        // Click event to close the cart summary when overlay is clicked
        overlay.addEventListener("click", () => toggleCartSummary(false));
    }
};

module.exports = function () {
    initCouponCarouselEvents();
    showPlaceOrderPopupError();
    showQtyUpdatedModal();
    disableAlternativeProductButton();

    if (mqueryRespond.status.mobile || mqueryRespond.status.tablet) {
        swipeTile();

        window.addEventListener("load", () => {
            setupSummarySwipe();
        });
    }

    $cache.body.off("click", ".remove-product").on("click", ".remove-product", e => {
        e.preventDefault();

        const $this = $(e.currentTarget);
        const actionUrl = $this.attr("data-action");
        const productID = $this.attr("data-pid");
        const brandID = $this.attr("data-brandid");
        let brandItems = parseInt($(`#js-current-products-${brandID}`).html(), 10);
        const uuid = $this.attr("data-uuid");
        const $deleteConfirmBtn = $(`.tile-delete-confirmation-btn[data-pid="${productID}"]`);

        if ($deleteConfirmBtn.length) {
            const $cartTile = $(`.ct-cart-tile[data-pid="${productID}"]`);
            const $cartTileRemovalBlock = $(`.ct-cart-tile-product-removed[data-pid="${productID}"]`);
            const undoDelayTime = $cartTileRemovalBlock.data("undo-delay");
            const availableProductAttr = $cartTile.attr("data-available") || false;
            const $checkoutContinue = $(".checkout-continue a.button");
            $checkoutContinue.attr("disabled", true);

            $cartTile.addClass("d-none");
            $cartTileRemovalBlock.removeClass("d-none");

            if (window.mqRespond.status.mobile && $this[0].dataset.originalTitle != "") {
                const $removeButton = $this[0];
                if ($removeButton.hasAttribute("aria-describedby")) {
                    const tooltipID = $removeButton.getAttribute("aria-describedby");
                    if (tooltipID) {
                        const tooltipElement = document.querySelector(`#${tooltipID}`);
                        if (tooltipElement) {
                            tooltipElement.remove();
                        }
                    }
                }
            }

            productRemovalActions[productID] = setTimeout(() => {
                $deleteConfirmBtn.data("action", actionUrl);
                $deleteConfirmBtn.data("uuid", uuid);
                $deleteConfirmBtn.first().trigger("click");
                $checkoutContinue.removeAttr("disabled");
                const unavailableProducts = $(`.js-out-of-stock-products-${brandID}`).children().length || 0;

                if (availableProductAttr && availableProductAttr != "false") {
                    brandItems = parseInt($(`#js-current-products-${brandID}`).html(), 10);

                    if (brandItems) {
                        if (brandItems - MIN_PRODUCT_QUANTITY <= 0 && !unavailableProducts) {
                            $(`.js-current-brand-${brandID}`).remove();

                            if (!$("[class*=js-current-brand-]").length) {
                                $(".checkout-btn").attr("disabled", true);
                            }
                        } else {
                            $(`#js-current-products-${brandID}`).text(brandItems - MIN_PRODUCT_QUANTITY);
                        }
                    }
                } else {
                    if (unavailableProducts && unavailableProducts - MIN_PRODUCT_QUANTITY <= 0) {
                        if (!brandItems) {
                            $(`.js-current-brand-${brandID}`).remove();
                        } else {
                            $(".js-unavailable-block").remove();
                        }
                    }
                }

            }, undoDelayTime);
        }

        $this.tooltip("hide");
    });

    $cache.body.on("click", ".ct-cart-tile-undo-remove", (e) => {
        e.preventDefault();

        const productID = $(e.currentTarget).data("pid");
        const $cartTile = $(`.ct-cart-tile[data-pid="${productID}"]`);
        const $cartTileRemovalBlock = $(`.ct-cart-tile-product-removed[data-pid="${productID}"]`);
        const $productsToRemove = $(".ct-cart-tile-product-removed:not(.d-none)").length;
        const $checkoutContinue = $(".checkout-continue a.button");

        clearTimeout(productRemovalActions[productID]);

        $cartTile.removeClass("d-none");
        $cartTileRemovalBlock.addClass("d-none");

        if ($productsToRemove <= 1 && $checkoutContinue.attr("disabled")) {
            $checkoutContinue.removeAttr("disabled");
        }
    });

    $cache.body.on("afterRemoveFromCart", function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $cache.body.off("click", ".cart-delete-confirmation-btn, .tile-delete-confirmation-btn").on("click", ".cart-delete-confirmation-btn, .tile-delete-confirmation-btn", function (e) {
        e.preventDefault();
        const isCartPage = $(".js-cart-page").length > 0;
        const $this = $(this);
        const productID = $this.data("pid");
        const uuid = $this.data("uuid");
        const $tile = $(`.product-tile.pid-${productID}`);
        const $pdpQtyContainer = $(`.ct-tile-quantity[data-pid="${productID}"]`);
        const $removedProductLayer = $(`.ct-cart-tile-product-removed[data-pid="${productID}"]`);
        const $removedCartTile = $(`.ct-cart-tile[data-pid="${productID}"]`);
        const $brandID = $tile.attr("data-brandID");
        let url = $this.data("action");
        let list = $this.closest(".gtm-list")?.data("gtm-list");
        let {gtmIndex, gtmList} = cartUtil.getGTMData($this, list);
        const urlParams = {
            pid: productID,
            uuid: uuid,
            isCart: isCartPage,
            gtmIndex: gtmIndex,
            gtmList: gtmList
        };

        url = urlUtils.appendToUrl(url, urlParams);

        $.spinner().start();
        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                confirmationToast.cleanConfirmationToast();
                confirmationToast.showConfirmationToast($this, null, 1, true);

                if (data.basket.items.length === 0 && isCartPage) {
                    $(".cart-page").html(data.emptyCartPage).removeClass("pwc-container--px-70");
                } else if (data.basket.items.length === 0 && !isCartPage) {
                    var $minicartWrapper = $(".minicart-wrapper");

                    $minicartWrapper.addClass("empty-cart");
                    $(".cart").empty().append("<div class=\"row\"> " +
                        "<div class=\"col-12 text-center\"> " +
                        "<h1>" + data.basket.resources.emptyCartMsg + "</h1> " +
                        "</div> " +
                        "</div>"
                    );
                    $(".number-of-items").empty().append(data.basket.resources.numberOfItems);
                    $(".minicart-quantity").empty().append(data.basket.numItems);
                    $(".minicart-link").attr({
                        "aria-label": data.basket.resources.minicartCountOfItems
                    });
                    $(".minicart .ct-popover").removeClass("show");
                    $cache.body.removeClass("modal-open");
                    scrollLock.disable(true);
                    $("html").removeClass("veiled");
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $(".uuid-" + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }

                    const $removedProductCategory = $removedCartTile.closest(".ct-category-line-items-container");
                    const $couponsAndPromotions = $cache.appliedCouponsWrapper.last();

                    $(".uuid-" + uuid).remove();

                    if (!data.basket.hasBonusProduct) {
                        $(".bonus-product").remove();
                    }

                    const $acumulaWrapper = $(".js-acumula-area");

                    if (data.basket.totalAcumulaDiscount && data.basket.totalAcumulaDiscount != "N/A") {
                        data.basket.totalAcumulaDiscount = removeCurrencyFromStringAndConverToNumber(data.basket.totalAcumulaDiscount);
                    }
                    if (data.basket && data.basket.totalAcumulaDiscount && data.basket.totalAcumulaDiscount != "0,00" && data.basket.totalAcumulaDiscount != "N/A") {
                        $acumulaWrapper.find(".total-discount-value").empty().append("€" + data.basket.totalAcumulaDiscount);
                        if ($acumulaWrapper.hasClass("d-none")) {
                            $acumulaWrapper.removeClass("d-none");
                        }
                    } else {
                        $acumulaWrapper.addClass("d-none");
                    }

                    $couponsAndPromotions.find(".ct-cart--applied-coupon-card").each((index, element) => {
                        $(element).remove();
                    });

                    $couponsAndPromotions.append(data.basket.totals.discountsHtml);
                    if (data.basket.loyaltyCoupons && isCartPage) {
                        const appliedCoupons = data.basket.loyaltyCoupons.gifts.concat(data.basket.loyaltyCoupons.vouchers);
                        const loyaltyCouponsHTML = buildLoyaltyCouponCardList(appliedCoupons);
                        $couponsAndPromotions.append(loyaltyCouponsHTML);
                    }

                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $cache.body.trigger("setShippingMethodSelection", data.basket);
                    validateBasket(data.basket);

                    if (!isCartPage) {
                        cartUtil.updateMinicartInfo(data);
                    }

                    if (isCartPage && data && data.basket) {
                        updateCouponsSummary(data.basket);
                    }
                    removeCartCategory($removedProductCategory);
                    $(".minicart").trigger("count:update", data.basket);
                }

                if ($tile.length > 0) {
                    $tile.closest(".product").removeClass("highlighted-in-red " + $brandID + "-color-highlighted");
                    $tile.attr("data-product-added-to-cart", "");
                    $tile.find(".add-to-cart").removeClass("hide");
                    $tile.find(".ct-tile-quantity").addClass("d-none");
                    $tile.find(".quantity-update").attr("data-previous-val", 0);
                    $cache.body.trigger("product:tileProductRemoval", $tile);
                }

                if ($pdpQtyContainer.length > 0) {
                    $pdpQtyContainer.siblings(".add-to-cart").removeClass("hide");
                    $(".add-to-cart.js-add-to-cart.js-add-to-cart-button").removeClass("d-none");
                    $pdpQtyContainer.addClass("d-none").siblings(".js-notes-container").find(".add-note, .add-note-section").addClass("d-none");
                    $pdpQtyContainer.find(".quantity-update").attr("data-previous-val", 0);
                }

                $removedProductLayer.removeClass("d-none");
                $removedCartTile.addClass("d-none");

                $cache.body.trigger("cart:update");
                cartUtil.updateProductQtyMap(data.basket);
                cartUtil.triggerCartUpdate();

                const $quickViewContainer = $(".js-product-quickview");
                const isQuickViewOpened = $quickViewContainer.length > 0 && $quickViewContainer.is(":visible");

                if (isCartPage && isQuickViewOpened) {
                    $("#quick-view-modal").modal("hide");
                }

                if ($this.hasClass("js-substitution-triggered")) {
                    $cache.body.trigger("cart:substitutionProductRemoved");
                    $this.removeClass("js-substitution-triggered");
                }

                const $jsProductInfo = $this.closest(".js-product-info");

                if ($jsProductInfo.length > 0 && $jsProductInfo.hasClass("item-unavailable")) {
                    document.dispatchEvent(new CustomEvent("dataLayer.alternativeProductsEvents", {
                        detail: {
                            "action": "remove product",
                            "availableskus": "",
                            "product": data?.removedProductGTMData?.productImpression.id
                        }
                    }));
                }

                if (data.dataLayerObject) {
                    document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", {
                        detail: {
                            "dataLayerObject": data.dataLayerObject
                        }
                    }));
                }

                // hide sections if Empty Cart
                const isEmptyCart = document.querySelectorAll(".ct-cart--empty-container").length;
                const acumulaArea = document.querySelector(".js-acumula-area");
                const poupaArea = document.querySelector(".js-poupa-area");

                if (!isEmptyCart) {
                    $.spinner().stop();
                    return;
                }

                acumulaArea.classList.add("d-none");
                poupaArea.classList.add("d-none");

                // disable inputs if Empty Cart
                const couponCodeInput = document.querySelector(".coupon-code-field");
                const selectAllCouponsInput = document.querySelector(".select-all-coupon-tiles");
                const carouselCouponsInputs = document.querySelectorAll(".coupon-carousel-input");

                couponCodeInput.disabled = true;
                if (selectAllCouponsInput && carouselCouponsInputs) {
                    selectAllCouponsInput.disabled = true;

                    carouselCouponsInputs.forEach(element => {
                        element.disabled = true;
                    });
                }

                $.spinner().stop();
            },
            error: function (err) {
                if ($tile.length > 0) {
                    let unit = $tile.find(".add-to-cart-measurement-unit").length > 0 ? " " + $tile.find(".add-to-cart-measurement-unit").first().text() : "";
                    $tile.find(".quantity-update").find(".add-to-cart-quantity").val($tile.find(".quantity-update").attr("data-previous-val") + unit);
                }
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $(".shippingMethods").change(function () {
        var url = $(this).attr("data-actionUrl");
        var urlParams = {
            methodID: $(this).find(":selected").attr("data-shipping-id")
        };
        // url = appendToUrl(url, urlParams);

        $(".totals").spinner().start();
        $.ajax({
            url: url,
            type: "post",
            dataType: "json",
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    const $couponsAndPromotions = $(".coupons-and-promos");

                    $couponsAndPromotions.find(".ct-cart--applied-coupon-card").each((index, element) => {
                        $(element).remove();
                    });
                    $couponsAndPromotions.append(data.totals.discountsHtml);

                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    /**
     * Event to add coupon code to the cart
     */
    $(".promo-code-form").off("submit").on("submit", function (e) {
        e.preventDefault();
        $.spinner().start();

        const $form = $(this);
        const $promoFormControl = $form.find(".form-control");
        const $couponErrorMessage = $form.find(".coupon-error-message");
        const $couponCodeElem = $form.find(".coupon-code-field");
        const $couponMissingError = $form.find(".coupon-missing-error");
        const couponCodeValue = $.trim($couponCodeElem.val());
        $couponCodeElem.val(couponCodeValue);

        clearCouponErrors();

        if (couponCodeValue && couponCodeValue.length) {
            $promoFormControl.removeClass("is-invalid");
            $couponErrorMessage.empty().addClass("d-none");

            // Fetch the form action URL
            let url = $form.attr("action");

            if (regex.values.giftId.test(couponCodeValue) || regex.values.voucherId.test(couponCodeValue)) {
                url = $form.data("add-loyalty-url");

                const $carouselTiles = $(".slick-slide:not(.slick-cloned) .coupon-carousel-input");
                const $isCarouselCouponField = $form.find(".is-carousel-coupon");

                $form.find(".coupon-description-field").val("");
                $isCarouselCouponField.val("");

                $carouselTiles.each((index, item) => {
                    const $item = $(item);
                    const $itemVal = $item.val();
                    if ($itemVal == couponCodeValue) {
                        const $couponCodeDescription = $item.attr("data-description");
                        const $formDescriptionInput = $form.find(".coupon-description-field");
                        $formDescriptionInput.val($couponCodeDescription);
                        $isCarouselCouponField.val(true);
                    }
                });
            }

            $.ajax({
                url: url,
                type: "GET",
                dataType: "json",
                data: $form.serialize(),
                success: function (data) {
                    if (!data || data.error) {
                        $promoFormControl.addClass("is-invalid");
                        $promoFormControl.attr("aria-describedby", "invalidCouponCode");

                        if (data && data.errorMessage) {
                            $couponErrorMessage.empty().append(data.errorMessage).removeClass("d-none");

                            // GTM logic - Start
                            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                                detail: {
                                    "success": false,
                                    "messageContent": data.errorMessage
                                }
                            }));
                            // GTM logic - End
                        }

                        $couponCodeElem.val(couponCodeValue);
                    } else if (data && data.totals) {
                        updateCouponsSummary(data);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $couponCodeElem.val(couponCodeValue);

                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        } else {
            $promoFormControl.addClass("is-invalid");
            $promoFormControl.attr("aria-describedby", "missing-coupon-code");
            $couponMissingError.removeClass("d-none");
            $.spinner().stop();
        }
        return false;
    });

    /**
     * Event to remove coupon from Cart
     */
    $cache.body.off("click", ".remove-coupon").on("click", ".remove-coupon", function (e, couponFromCarousel) {
        e.preventDefault();

        var couponCode = $(this).data("code");
        var uuid = $(this).data("uuid");
        var $deleteConfirmBtn = $(".delete-coupon-confirmation-btn");

        $deleteConfirmBtn.data("uuid", uuid);
        $deleteConfirmBtn.data("code", couponCode);

        if (couponFromCarousel) {
            $deleteConfirmBtn.trigger("click");
            return;
        }

        getMessageAndShowRemovalConfirmModal();
    });

    /**
     * Event to remove coupon carousel from cart
     */
    $cache.body.off("click", ".js-delete-coupon-confirmation").on("click", ".js-delete-coupon-confirmation", function (e, couponData) {
        e.preventDefault();
        $.spinner().start();

        var url = $(".js-delete-coupon-confirmation").val();
        var uuid = couponData;
        var couponCode = couponData;
        if (regex.values.giftId.test(couponCode) || regex.values.voucherId.test(couponCode)) {
            url = $(".js-delete-coupon-confirmation").val();
        }
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = urlUtils.appendToUrl(url, urlParams);

        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                if (data) {
                    $(".coupon-uuid-" + uuid).remove();
                    $(".coupon-carousel-input[name='coupon-" + uuid + "']").prop("checked", false);

                    updateSelectAllCouponsInput();

                    if (typeof data.totalNumberOfProducts != "undefined" && data.totalNumberOfProducts > 0) {
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        updateCartProductTilesPriceInformation(data);
                    }

                }

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
            complete: () => {
                setTimeout(() => {
                    $("#js-trigger-checkbox").trigger("click");
                }, 100);
            }
        });
    });

    /**
     * Event to remove coupon from cart after user confirms
     */
    $cache.body.off("click", ".delete-coupon-confirmation-btn").on("click", ".delete-coupon-confirmation-btn", function (e) {
        e.preventDefault();
        $.spinner().start();

        var $this = $(this);
        var url = $this.data("action");
        var uuid = $this.data("uuid");
        var couponCode = $this.data("code");
        if (regex.values.giftId.test(couponCode) || regex.values.voucherId.test(couponCode)) {
            url = $this.data("remove-loyalty-url");
        }
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = urlUtils.appendToUrl(url, urlParams);

        $("body > .modal-backdrop").remove();

        $.ajax({
            url: url,
            type: "get",
            dataType: "json",
            success: function (data) {
                if (data) {
                    $(".coupon-uuid-" + uuid).remove();
                    $(".coupon-carousel-input[name='coupon-" + uuid + "']").prop("checked", false);

                    updateSelectAllCouponsInput();

                    if (typeof data.totalNumberOfProducts != "undefined" && data.totalNumberOfProducts > 0) {
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        updateCartProductTilesPriceInformation(data);
                    }
                }

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
            complete: () => {
                setTimeout(() => {
                    $("#js-trigger-checkbox").trigger("click");
                }, 100);
            }
        });
    });

    $cache.body.on("hidden.bs.modal", "#chooseBonusProductModal", function () {
        $("#chooseBonusProductModal").remove();
        $(".modal-backdrop").remove();
        $cache.body.removeClass("modal-open");
        scrollLock.disable();

        if ($(".cart-page").length) {
            $(".launched-modal .btn-outline-primary").trigger("focus");
            $(".launched-modal").removeClass("launched-modal");
        } else {
            $(".product-detail .add-to-cart").focus();
        }
    });

    $cache.body.on("shown.bs.modal", "#editProductModal", function () {
        $("#editProductModal").siblings().attr("aria-hidden", "true");
        $("#editProductModal .close").focus();
    });

    $cache.body.on("hidden.bs.modal", "#editProductModal", function () {
        $("#editProductModal").siblings().attr("aria-hidden", "false");
    });

    $cache.body.on("keydown", "#editProductModal", function (e) {
        var focusParams = {
            event: e,
            containerSelector: "#editProductModal",
            firstElementSelector: ".close",
            lastElementSelector: ".update-cart-product-global",
            nextToLastElementSelector: ".modal-footer .quantity-select"
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    /**
     * Update product in the cart
     */
    $cache.body.on("product:updateAddToCart", function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");

        $(".update-cart-product-global", dialog).attr("disabled",
            !$(".global-availability", dialog).data("ready-to-order")
            || !$(".global-availability", dialog).data("available")
        );
    });

    /**
     * Update product availability
     */
    $cache.body.on("product:updateAvailability", function (e, response) {
        // bundle individual products
        $(".product-availability", response.$productContainer)
            .data("ready-to-order", response.product.readyToOrder)
            .data("available", response.product.available)
            .find(".availability-msg")
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest(".quick-view-dialog");

        if ($(".product-availability", dialog).length) {
            // bundle all products
            var allAvailable = $(".product-availability", dialog).toArray()
                .every(function (item) { return $(item).data("available"); });

            var allReady = $(".product-availability", dialog).toArray()
                .every(function (item) { return $(item).data("ready-to-order"); });

            $(".global-availability", dialog)
                .data("ready-to-order", allReady)
                .data("available", allAvailable);

            $(".global-availability .availability-msg", dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $(".global-availability", dialog)
                .data("ready-to-order", response.product.readyToOrder)
                .data("available", response.product.available)
                .find(".availability-msg")
                .empty()
                .html(response.message);
        }
    });

    /**
     * Event for product after atribute select
     */
    $cache.body.on("product:afterAttributeSelect", function (e, response) {
        if ($(".modal.show .product-quickview .bundle-items").length) {
            $(".modal.show").find(response.container).data("pid", response.data.product.id);
            $(".modal.show").find(response.container).find(".product-id").text(response.data.product.id);
        } else {
            $(".modal.show .product-quickview").data("pid", response.data.product.id);
        }
    });

    /**
     * Event for product quantity change
     */
    $cache.body.on("change", ".quantity-select", function () {
        var selectedQuantity = $(this).val();
        $(".modal.show .update-cart-url").data("selected-quantity", selectedQuantity);
    });

    /**
     * Event for product options change
     */
    $cache.body.on("change", ".options-select", function () {
        var selectedOptionValueId = $(this).children("option:selected").data("value-id");
        $(".modal.show .update-cart-url").data("selected-option", selectedOptionValueId);
    });

    /**
     * Event for edit product on the cart page
     */
    $cache.body.off("click", ".ct-cart-tile-product-link").on("click", ".ct-cart-tile-product-link", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(e.currentTarget);
        const isEntregaZeroProduct = $this.data("is-entrega-zero");
        const isVariationProduct = $this.data("is-variant");

        if (isEntregaZeroProduct) {
            $("#entregazero-details").modal("show");
            cartUtil.updateCartSummaryModalClass(true);
        } else if (isVariationProduct) {
            const pid = $this.data("pid");
            $cache.body.find(".quickview.selectable[data-lid='" + pid + "']").click();
            $.spinner().start();
        }
    });

    /**
     * Event for product cart update
     */
    $cache.body.off("click", ".update-cart-product-global").on("click", ".update-cart-product-global", function (e) {
        e.preventDefault();

        const $this = $(this);
        const $quickViewModal = $("#quick-view-modal");
        const productQtyMap = cartUtil.getProductQtyMap();
        const updateProductUrl = $(this).data("update-variant-url");
        const originalPid = $quickViewModal.data("original-pid");
        const basketItem = productQtyMap.items.find(el => el.id == originalPid.toString());
        const uuid = basketItem.UUID;
        const pid = cartUtil.getPidValue($this);
        const form = {
            uuid: uuid,
            pid: pid,
            quantity: cartUtil.getQuantitySelected($this),
            isCartPage: $(".js-cart-page").length > 0
        };

        $quickViewModal.spinner().start();

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: "post",
                context: this,
                data: form,
                dataType: "json",
                success: function (data) {
                    const $couponsAndPromotions = $(".coupons-and-promos");

                    $("#quick-view-modal").modal("hide");
                    $couponsAndPromotions.find(".ct-cart--applied-coupon-card").each((index, element) => {
                        $(element).remove();
                    });
                    $couponsAndPromotions.append(data.cartModel.totals.discountsHtml);

                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    validateBasket(data.cartModel);

                    $cache.body.trigger("cart:update");
                    cartUtil.updateProductQtyMap(data.cartModel);
                    cartUtil.triggerCartUpdate();

                    var currentQty = $(`.ct-tile-quantity[data-pid="${originalPid}"]`);
                    currentQty.replaceWith(data.qtyInputHtml);

                    initializeQtyComponent(pid, ".ct-cart-tile-qty");

                    updateProductDetails(data, uuid, originalPid);

                    $quickViewModal.removeAttr("data-original-pid");

                    //GTM logic
                    if (data.removedProductDataLayerObject) {
                        document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", {
                            detail: {
                                "dataLayerObject": data.removedProductDataLayerObject
                            }
                        }));
                    }

                    if (data.addedProductDataLayerObject) {
                        document.dispatchEvent(new CustomEvent("dataLayer.addToCart", {
                            detail: {
                                "dataLayerObject": data.addedProductDataLayerObject
                            }
                        }));
                    }
                    //GTM logic

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
                complete: () => {
                    triggerInitWishlistTogglers();
                    initAddNoteBtns();
                }
            });
        }
    });

    /**
     * Event for allow product substitute
     */
    $cache.body.off("change", "form[name='updateSubstitute'] input[name='substitute']").on("change", "form[name='updateSubstitute'] input[name='substitute']", function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var input = $(e.target);
        var form = input.parents("form");
        var updateSubstituteUrl = form.length ? form.attr("action") : null;

        if (updateSubstituteUrl) {
            $.ajax({
                url: updateSubstituteUrl,
                type: "POST",
                context: this,
                data: {
                    pid: form.data("pid"),
                    substitute: input.prop("checked")
                },
                dataType: "json",
                success: function (data) {
                    if (!data.success && "allowSubstitution" in data) {
                        input.prop("checked", data.allowSubstitution);
                    }
                },
                error: function () {
                    window.location.reload();
                }
            });
        }
    });

    /**
     * Event to trigger the opening of the popup for alternative products
     */
    $cache.body.off("click", ".js-alternative-products").on("click", ".js-alternative-products", function (e) {
        e.preventDefault();

        const $this = $(this);
        const origPID = $this.attr("data-orig-pid");
        const showAlternativeUrl = $this.data("url");
        const alternativeOriginalProductData = $this.attr("data-orig-product-data");
        const alternativeResources = $this.attr("data-resources");
        let data = {};
        let alternativeProductsObj = {
            originalProduct: alternativeOriginalProductData ? JSON.parse(alternativeOriginalProductData) : null,
            resources: alternativeResources ? JSON.parse(alternativeResources) : null,
            alternativeProducts: null,
            alternativeProductIDs: null
        };

        if (origPID) {
            data.origPID = origPID;
            $.spinner().start(true);

            $.ajax({
                url: showAlternativeUrl,
                type: "GET",
                dataType: "JSON",
                data: data,
                success: function (response) {
                    if (response && response.success) {
                        response.alternativeProducts = removeAlternativeProductsPartOfBasket(response.alternativeProducts);

                        if (!response.alternativeProducts) {
                            $this.attr("disabled", "disabled");
                            return;
                        }

                        alternativeProductsObj.alternativeProducts = response.alternativeProducts;
                        alternativeProductsObj.alternativeProductIDs = response.alternativeProductIDs;
                        alternativeProductsObj.headerTitle = response.headerTitle;
                        alternativeProductsObj.notAvailableAlternativeProductsMessage = response.notAvailableAlternativeProductsMessage;

                        altProductsCarouselVueJS.initVueAlternativeProducts(".alternative-products-view-carousel" + origPID + "", alternativeProductsObj);

                        const $alternativesView = $(`.alternative-products-view[data-pid="${origPID}"]`);

                        if ($alternativesView.length > 0) {
                            $alternativesView.removeClass("d-none");
                            $this.addClass("d-none");
                        }

                        const $imageContainer = $(".ct-image-container");
                        const $ctPdpLink = $(".ct-pdp-link");
                        if ($imageContainer.length > 0 && $ctPdpLink.length > 0) {
                            $imageContainer.find("a").removeAttr("href").css({"pointer-events":"none"});
                            $imageContainer.addClass("checkout-alternative-products");
                            $ctPdpLink.find("a").removeAttr("href").css({"pointer-events":"none"});
                        }
                        $.spinner().stop();
                        loadLazyImages();
                        loadingDots(".js-alternative-product-replace");
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    /**
     * Event to trigger the process to replace the out of stock product with a product in stock
     */
    $cache.body.off("click", ".js-alternative-product-replace").on("click", ".js-alternative-product-replace", function (e) {
        e.preventDefault();
        confirmationToast.cleanConfirmationToast();
        let currentTarget = e.currentTarget;
        let $this = $(this);
        const origPID = $this.attr("data-orig-pid");
        const productID = $this.attr("data-product-id");
        const url = $this.attr("data-url");
        const brandID = $this.closest(".current-brand").attr("data-brand-id");
        const unavailableProducts = $(`.js-out-of-stock-products-${brandID}`).children().length || 0;
        const gtmList = $this.closest(".gtm-list")?.data("gtm-list");
        let $alternativeModal = $("#alternative-product-modal");
        let data = {};

        if (origPID) {
            data.origPID = origPID;
            data.alternativeID = productID;
            data.gtmList = gtmList;
            $(".cart-category-list-items").spinner().start();

            $.ajax({
                url: url,
                type: "POST",
                data: data,
                success: function (response) {
                    if (typeof response == "object" && !response.success) {
                        $this.attr("disabled", "disabled");
                        disableLoadingDots(currentTarget);
                        $.spinner().stop();
                    } else {
                        confirmationToast.showConfirmationToast($this, null, 1, false);
                        $alternativeModal.modal("hide");
                        $cache.body.removeClass("modal-open");
                        scrollLock.disable(true);
                        $(".js-alternative-products[data-orig-pid='" + origPID + "']").closest(".js-product-info").fadeOut("normal", function () {
                            const brandID = $(this).data("brand-id");
                            const qtyProducts = parseInt($(`#js-current-products-${brandID}`).html(), 10);

                            if (unavailableProducts <= 1) {
                                if (qtyProducts === 0) {
                                    $this.closest(".currentBrand")?.remove();
                                } else {
                                    $(this).closest(".js-unavailable-block")?.remove();
                                }
                            }
                        });
                        updateProductAreaAfterReplace(response);

                        const $qtyContainer = $(`.ct-tile-quantity[data-pid="${productID}"]`);
                        const $cartTile = $(`.js-product-info[data-pid="${productID}"]`);
                        const cartSummaryString = $cartTile.attr("data-cart-summary");
                        let cartSummaryObject;

                        try {
                            cartSummaryObject = JSON.parse(cartSummaryString);
                        } catch {
                            cartSummaryObject = null;
                        }

                        if (cartSummaryObject) {
                            //Updates the cart summary
                            updateCartSummary(cartSummaryObject);
                            updateCouponsSummary(cartSummaryObject);
                        }

                        const newProductQtyMap = $qtyContainer.closest(".js-product-info").attr("data-productqtymap");
                        $(".minicart .ct-popover").attr("data-productqtymap", newProductQtyMap);

                        try {
                            const productMapObj = JSON.parse(newProductQtyMap);
                            cartUtil.refreshProductQtyMap(productMapObj.items);

                            //GTM logic start
                            const alternativeIDs = $(".alternative-products-list-ids")?.data("alternative-ids");
                            document.dispatchEvent(new CustomEvent("dataLayer.alternativeProductsEvents", {
                                detail: {
                                    "action": "change product",
                                    "availableskus": alternativeIDs,
                                    "product": [origPID, productID].join("|")
                                }
                            }));

                            if (response.removedProductDataLayerObject) {
                                document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", {
                                    detail: {
                                        "dataLayerObject": response.removedProductDataLayerObject
                                    }
                                }));
                            }
        
                            if (response.addedProductDataLayerObject) {
                                document.dispatchEvent(new CustomEvent("dataLayer.addToCart", {
                                    detail: {
                                        "dataLayerObject": response.addedProductDataLayerObject
                                    }
                                }));
                            }
                            //GTM logic end
                        } catch {
                            window.location.reload();
                        }

                        cartUtil.triggerCartUpdate();

                        $.spinner().stop();
                    }
                },
                error: function () {
                    $alternativeModal.modal("hide");
                    $.spinner().stop();
                    window.location.reload();
                },
                complete: function (response) {
                    if (response.responseText) {
                        const isVueInitialized = !$(`.ct-tile-quantity[data-pid="${productID}"]`).find("template").length;
                        const $templateProduct = $(`.product-info.js-product-info[data-pid="${productID}"]`);
                        let selectedUnit = null;

                        if ($templateProduct.length > 0) {
                            selectedUnit = $templateProduct.data("selected-unit");
                        }

                        if (!isVueInitialized) {
                            initializeQtyComponent(productID, ".ct-cart-tile-qty", selectedUnit);
                        }

                        initAddNoteBtns();
                    }

                    loadLazyImages();
                }
            });
        }
    });

    const $cartTileBottomDetailsTogglerBtns = document.querySelectorAll(".ct-cart-tile-bottom-details-toggle-btn");

    $cartTileBottomDetailsTogglerBtns.forEach(element => {
        $(element).off("click").on("click", e => {
            const $cartTileBottomDetailsTogglerBtn = e.currentTarget;
            const $cartTileBottomDetails = $cartTileBottomDetailsTogglerBtn.parentNode.nextElementSibling;
            const $cartTileNotesContainer = $cartTileBottomDetails.nextElementSibling;
            const $notesWrapper = $cartTileNotesContainer.querySelector(".js-notes-container");
            const $notesSection = $cartTileNotesContainer.querySelector(".add-note-section");

            if (!$notesWrapper.classList.contains("d-none") && $cartTileBottomDetailsTogglerBtn.classList.contains("opened") && $cartTileBottomDetails.classList.contains("active")) {
                $($notesSection).stop().slideUp("slow", () => {
                    $notesWrapper.classList.add("d-none");
                    $notesSection.classList.add("d-none");
                    $($cartTileBottomDetails).stop().slideToggle("slow", () => {
                        $cartTileBottomDetails.classList.remove("d-none");
                        $cartTileBottomDetails.removeAttribute("style");
                    });
                });
                $cartTileBottomDetailsTogglerBtn.classList.remove("opened");
                return;
            }

            $($cartTileBottomDetails).stop().slideToggle("slow", () => {
                $cartTileBottomDetails.classList.toggle("active", !$cartTileBottomDetails.classList.contains("active"));
                $notesSection.removeAttribute("style");
            });
            $cartTileBottomDetailsTogglerBtn.classList.toggle("opened", !$cartTileBottomDetailsTogglerBtn.classList.contains("opened"));
        });
    });

    initAddNoteBtns();

    const $cartNotesSubmitBtns = document.querySelectorAll(".ct-cart-tile-notes .js-add-note-button");

    $cartNotesSubmitBtns.forEach(element => {
        $(element).off("click").on("click", e => {
            const $notesForm = $(e.currentTarget).closest(".add-note-form");
            const productID = $notesForm.find(".add-product-note")[0].dataset.pid;
            const $cartBottomDetails = document.querySelector(`.ct-cart-tile-bottom-details[data-pid="${productID}"]`);
            const $cartProductNotes = document.querySelector(`.ct-cart-tile-notes[data-pid="${productID}"] .js-notes-container`);

            $cartProductNotes.classList.add("d-none");
            $cartBottomDetails.classList.remove("d-none");
        });
    });

    // Fix for IOS not triggering blur on tap out
    if (isIOS()) {
        $("#maincontent").click(e => {
            if ($(e.target).is("input, select, textarea")) { return; }
            document.activeElement.blur();
        });

        $("input, select, textarea").click(e => {
            e.stopPropagation();
        });
    }

    initCartCouponsEvents();
    bindCouponFormEvents();

    cartUtil.adjustProductListBottomSpacing();
    stickySummaryWrapperInit(false);

    cartUtil.setCartNotesDisplay();
    cartUtil.adjustSummaryBlocks();

    const $cartSummaryPlasticBagInfo = $(".ct-cart--summary-plastic-bag-info");

    if (window.mqRespond.status.mobile && $cartSummaryPlasticBagInfo) {
        $(".ct-cart--summary-plastic-bag-info").removeAttr("href");
    }

    $(window).on("resize", debounce(() => {
        cartUtil.adjustProductListBottomSpacing();
        cartUtil.setCartNotesDisplay();
        cartUtil.adjustSummaryBlocks();
    }, 200));

    /**
    * removes unavailable products from cart and reloads the cart page
    */
    $cache.body.off("click", ".remove-unaivailable-products-confirmation-btn").on("click", ".remove-unaivailable-products-confirmation-btn", e => {
        const $this = $(e.currentTarget);
        var url = $this.data("url");
        const list = $this.closest(".gtm-list")?.data("gtm-list");
        const urlParams = {
            gtmList: list
        };

        url = urlUtils.appendToUrl(url, urlParams);

        $.get(url, response => {
            // remove css
            if (response.dataLayerObject) {
                document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", { detail: { "dataLayerObject": response.dataLayerObject } }));
            }
            window.location.href = response.redirectUrl;
        });
    });

    if ($cache.pageTypeValue == CART) {
        initProductQuantity();
    }

    $(document).ready(() => {
        let couponCodeField = $(".coupon-code-field");
        if (couponCodeField) {
            couponCodeField.autocomplete = "on";
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    base.saveTileToLocalStorage();
};
